import Button from "@mui/material/Button";
import IconButton from '@mui/material/IconButton';
import CircleIcon from '@mui/icons-material/Circle';
import CheckIcon from '@mui/icons-material/Check';
import SyncIcon from '@mui/icons-material/Sync';
import { useTheme } from '@mui/material/styles';



export default function GrowingButton({ title, state }: { title: string , state: boolean}) {
  const theme = useTheme();
  return (
    <IconButton
      // variant="outlined"
      // startIcon={<CircleIcon />}
      sx={{
        //backgroundColor: theme.palette.primary.main,
        backgroundColor: '#beedbe',
        //color: theme.palette.primary.contrastText,
        color: '#3fa63f',

        opacity: .4,

        animation: "pulse 1.5s ease-in-out infinite",

        "@keyframes pulse": {
          "0%": {
            transform: "scale(1)",
            opacity: .1,
          },
          "50%": {
            transform: "scale(1.18)",
            opacity: .9,
          },
          "100%": {
            transform: "scale(1)",
            opacity: .1,
          },
        },
      }}
    >
    {state ? <SyncIcon /> : <CheckIcon />}
    {/* {title} */}
    </IconButton>
  );
}